import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Crosshair, Move, Building2 } from 'lucide-react';
import { Lang } from '../types';
interface BenefitsProps {
  lang: Lang;
}
const content = {
  en: {
    title: 'What You Get at Barboxa Ink',
    benefits: [{
      num: '01',
      icon: PenTool,
      title: '100% Custom Design',
      desc: "No copy/paste. Your tattoo is built around <strong class='text-studio-text font-medium'>your concept, your body, and your style.</strong> Every line has a reason."
    }, {
      num: '02',
      icon: Crosshair,
      title: 'Real Fine Line Precision',
      desc: "Fine line isn't just \"thin lines.\" It's about <strong class='text-studio-text font-medium'>control, balance, and a finish</strong> that looks sharp in person AND in photos."
    }, {
      num: '03',
      icon: Move,
      title: 'Expert Placement Guidance',
      desc: "Before we tattoo anything, I'll advise you on <strong class='text-studio-text font-medium'>size, placement, and detail level</strong> — so your piece looks great today and 10 years from now."
    }, {
      num: '04',
      icon: Building2,
      title: 'Professional Studio Experience',
      desc: "Your session happens at <strong class='text-studio-text font-medium'>Piajas Ink Tattoo Studio</strong> — a clean, professional environment where you feel comfortable from start to finish."
    }]
  },
  es: {
    title: 'Lo que obtienes con Barboxa Ink',
    benefits: [{
      num: '01',
      icon: PenTool,
      title: 'Diseño 100% personalizado',
      desc: "Sin copiar/pegar. Tu tatuaje se construye alrededor de <strong class='text-studio-text font-medium'>tu concepto, tu cuerpo y tu estilo.</strong> Cada línea tiene una razón."
    }, {
      num: '02',
      icon: Crosshair,
      title: 'Precisión Fine Line real',
      desc: 'El Fine Line no es solo "líneas delgadas." Es <strong class=\'text-studio-text font-medium\'>control, balance y un acabado</strong> que se ve limpio en persona Y en fotos.'
    }, {
      num: '03',
      icon: Move,
      title: 'Guía experta de ubicación',
      desc: "Antes de tatuar nada, te asesoro sobre <strong class='text-studio-text font-medium'>tamaño, zona y nivel de detalle</strong> — para que se vea impecable hoy y en 10 años."
    }, {
      num: '04',
      icon: Building2,
      title: 'Experiencia profesional en estudio',
      desc: "Tu sesión se realiza en <strong class='text-studio-text font-medium'>Piajas Ink Tattoo Studio</strong> — un ambiente limpio y profesional donde te sientes cómodo de principio a fin."
    }]
  }
};
export function BenefitsSection({
  lang
}: BenefitsProps) {
  const t = content[lang];
  return <section id="benefits" className="py-12 md:py-16 bg-studio-bg" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-center mb-8 md:mb-10" data-id="element-3">
          {t.title}
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-4">
          {t.benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="p-5 md:p-8 border border-studio-border bg-studio-bgAlt/50 hover:bg-studio-bgAlt transition-colors duration-300 group" data-id="element-5">
                <div className="flex items-center justify-between mb-4 md:mb-6" data-id="element-6">
                  <div className="w-12 h-12 rounded-full border border-studio-border flex items-center justify-center text-studio-accent group-hover:scale-110 transition-transform duration-300" data-id="element-7">
                    <Icon size={24} strokeWidth={1.5} data-id="element-8" />
                  </div>
                  <span className="text-4xl font-playfair text-studio-border font-bold group-hover:text-studio-accent/20 transition-colors duration-300" data-id="element-9">
                    {benefit.num}
                  </span>
                </div>
                <h3 className="text-2xl font-playfair font-semibold mb-4 text-studio-text" data-id="element-10">
                  {benefit.title}
                </h3>
                <p className="text-studio-muted leading-relaxed" dangerouslySetInnerHTML={{
              __html: benefit.desc
            }} data-id="element-11" />
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}